import {
  submitFedexMfaDataInputSchema,
  submitFedexMfaDataOutputSchema,
} from "@redotech/redo-model/fulfillments/fedex-customer-registration";

export const submitFedexMfaData = {
  name: "submitFedexMfaData" as const,
  input: submitFedexMfaDataInputSchema,
  output: submitFedexMfaDataOutputSchema,
};
